import React from 'react';
import { useTranslate } from 'react-admin';

import PIAvailabilityForm from './PIAvailabilityForm';
import { Drawer } from '~/components';
import { EditForm } from '~/components/ra';
import { productLabel as l } from '.';
import { Solution } from '~/types';
import { PIAvailability } from '~/types/solutions';

interface Props {
  record: PIAvailability | null;
  solutionRecord: Solution;
  open: boolean;
  onClose: () => void;
  closeParent: () => void;
  permissions: string[];
}

const PIAvailabilityEdit = (props: Props) => {
  const { record, solutionRecord, open, onClose, closeParent, permissions } = props;

  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  const closeAll = () => {
    onClose();
    closeParent();
  };

  return (
    <Drawer heading={t('editPaymentInstrument')} open={open} onClose={onClose}>
      {record && (
        <EditForm
          resource='paymentInstrumentAvailabilityRules'
          target='solutions'
          id={solutionRecord.id}
          resourceId={record.id}
          record={record}
          closeParent={closeAll}
          withDelete
          disabled={!permissions?.includes('solution.paymentInstrumentAvailabilityRules.update')}
          withSaveConfirmation
          saveConfirmationSettings={{
            variant: 'drawer',
            drawer: { heading: translate('utils.confirmConfigurationChanges') },
          }}
          withDeleteConfirmation
          deleteButtonProps={{
            variant: 'delete',
            disabled: !permissions?.includes('solution.paymentInstrumentAvailabilityRules.delete'),
          }}
        >
          <PIAvailabilityForm record={record} solutionRecord={solutionRecord} edit />
        </EditForm>
      )}
    </Drawer>
  );
};

export default PIAvailabilityEdit;
